import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  getDataBoundaryFailed,
  getDataBoundaryStart,
  getDataBoundarySuccess,
} from "../redux/getDataBoundary";
import { getDataBoundaryApi } from "core/http/service/recruitment";

import { formInputRecruitmentSelector } from "../redux/selector";
import moment from "moment";
import { formRecruitmentUpdate } from "../redux/formInput";

function* getDataBoundaryWork() {
  const { departmentLevel2Code, departmentLevel3Code, departmentLevel1Code } =
    yield select(formInputRecruitmentSelector);
  try {
    const res = yield call(getDataBoundaryApi, {
      year: moment().year(),
      departmentCode:
        departmentLevel3Code || departmentLevel2Code || departmentLevel1Code,
    });
    yield put({
      type: getDataBoundarySuccess.type,
      payload: res,
    });
    if (res && res.length) {
      yield put({
        type: formRecruitmentUpdate.type,
        payload: {
          totalHuman: res[0]?.totalHuman,
          boundaryQuantity:
            res[0]?.lastEditQuantity || res[0]?.boundaryQuantity,
        },
      });
    }
  } catch (error) {
    yield put({
      type: getDataBoundaryFailed.type,
    });
  }
}

function* watchGetListManagers() {
  yield takeLatest(getDataBoundaryStart.type, getDataBoundaryWork);
}

export default function* getDataBoundarySaga() {
  yield all([watchGetListManagers()]);
}
